import { PropsWithChildren, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { TLocationName } from '../location.t';
import { useDispatch } from 'react-redux';
import { locationSlice } from '../locationReducer';

type ILocationLinkProps = PropsWithChildren<{
    locationName: TLocationName,
    className?: string
}>

function LocationLink(props: ILocationLinkProps) {
    const { children, locationName, className = '' } = props;
    const dispatch = useDispatch();

    const onClickHandler = useCallback((e) => {
        e.preventDefault();
        dispatch(locationSlice.actions.openLocationAction({ name: locationName }));
    }, [dispatch, locationName]);

    return <Link to={'#'} className={className} onClick={onClickHandler}>
        {children}
    </Link>
}

export default LocationLink;
